// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.scl--pvc-box-container-style{
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 15px;
}

.scl--pvc-box-container-style .diff-section-box .ttbc{
    border-bottom: 1px solid rgba(229, 229, 231, 1);
    padding-top: 15px;
    padding-bottom: 15px;
}

.scl--pvc-box-container-style .diff-section-box .ttbc h6::first-letter{
   text-transform: uppercase;
}

.scl--pvc-box-container-style .diff-section-box{
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.scl--pvc-box-container-style .diff-section-box .ttbc h6{
    font-size: 20px;
    font-weight: bold;
    color: rgba(50, 53, 57, 1);
}

.scl--pvc-box-container-style .diff-section-box .preview-list-item .preview-list-item-body{
    display: flex;
    flex-direction: column;
    gap: 15px;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/workflow/css/preview-content.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":["\n\n.scl--pvc-box-container-style{\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-top: 15px;\n}\n\n.scl--pvc-box-container-style .diff-section-box .ttbc{\n    border-bottom: 1px solid rgba(229, 229, 231, 1);\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.scl--pvc-box-container-style .diff-section-box .ttbc h6::first-letter{\n   text-transform: uppercase;\n}\n\n.scl--pvc-box-container-style .diff-section-box{\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.scl--pvc-box-container-style .diff-section-box .ttbc h6{\n    font-size: 20px;\n    font-weight: bold;\n    color: rgba(50, 53, 57, 1);\n}\n\n.scl--pvc-box-container-style .diff-section-box .preview-list-item .preview-list-item-body{\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
